import { render, staticRenderFns } from "./StreetsMap.vue?vue&type=template&id=23534c1c&scoped=true&"
import script from "./StreetsMap.vue?vue&type=script&lang=ts&"
export * from "./StreetsMap.vue?vue&type=script&lang=ts&"
import style0 from "./StreetsMap.vue?vue&type=style&index=0&id=23534c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23534c1c",
  null
  
)

export default component.exports